// Tools tab on the phone customer file: every heavy wizard is listed, but each just explains it's a desktop job.
import { useState } from "react";
import { CalendarClock, FileSignature, FileText, Gavel, Package, Receipt, Send } from "lucide-react";
import { DesktopOnlyDialog } from "@/components/phone/DesktopOnlyNote";
import { cn } from "@/lib/utils";

const TOOLS = [
  { key: "payment-plan", label: "Payment plan", icon: CalendarClock, tone: "text-indigo-700 bg-indigo-50", hide: (c) => ["written_off", "bad_debt"].includes(c.stage) },
  { key: "generate-doc", label: "Generate document", icon: FileText, tone: "text-slate-700 bg-slate-100" },
  { key: "statement", label: "Statement", icon: Receipt, tone: "text-emerald-700 bg-emerald-50" },
  { key: "payout-letter", label: "Payout letter", icon: Send, tone: "text-blue-700 bg-blue-50" },
  { key: "service-pack", label: "Service pack", icon: Package, tone: "text-amber-700 bg-amber-50", legalOnly: true },
  { key: "witness-statement", label: "Witness statement", icon: FileSignature, tone: "text-rose-700 bg-rose-50", legalOnly: true },
  { key: "pre-chase", label: "Pre-chase", icon: Gavel, tone: "text-orange-700 bg-orange-50", collectionsOnly: true },
];

export function PhoneTools({ caseRow, isLegalMode }) {
  const [open, setOpen] = useState(null);
  const tools = TOOLS.filter((t) => !(t.hide && t.hide(caseRow)) && !(t.legalOnly && !isLegalMode) && !(t.collectionsOnly && isLegalMode));
  return (
    <div className="p-3" data-testid="phone-tools">
      <p className="text-[12px] text-slate-500 mb-3">These wizards need a bigger screen. Tap one to see what it does and where to run it.</p>
      <div className="grid grid-cols-2 gap-2">
        {tools.map((t) => (
          <button key={t.key} type="button" onClick={() => setOpen(t)} className="flex items-center gap-3 rounded-xl border bg-white p-3 text-left sf-tap active:bg-slate-50" data-testid={`phone-tool-${t.key}`}>
            <span className={cn("h-10 w-10 rounded-lg flex items-center justify-center shrink-0", t.tone)}><t.icon className="w-5 h-5" /></span>
            <span className="text-[13px] font-medium text-slate-800 leading-tight">{t.label}</span>
          </button>
        ))}
      </div>
      {open && <DesktopOnlyDialog title={open.label} onClose={() => setOpen(null)} />}
    </div>
  );
}
